module.exports = __webpack_public_path__ + "img/ic_play.4a0eb106.svg";